import React, { useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { color } from "framer-motion";
import {Link} from "react-router-dom"

function ForgotPassword() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  const startCooldown = () => {
    setCooldown(30);
    const interval = setInterval(() => {
      setCooldown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const sendRequest = async (email) => {
    return axios.post(`${API_BASE_URL}/auth/forgot-password`, { email });
  };

  const onSubmit = async (data) => {
    setLoading(true);
    setStatus("");

    try {
      const res = await sendRequest(data.email);
      setStatus(res.data.message || "Reset link sent");
      startCooldown();
    } catch (err) {
      setStatus(err?.response?.data?.message || "Error sending email");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    const email = getValues("email");
    if (!email) return setStatus("Enter email first");

    setResendLoading(true);
    setStatus("");

    try {
      const res = await sendRequest(email);
      setStatus("Email resent successfully");
      startCooldown();
    } catch (err) {
      setStatus("Failed to resend");
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-lg-5 d-none d-lg-flex vh-100 bg-primary-transparent align-items-center justify-content-center">
        <img src="/assets/img/authentication-bg.svg" alt="" />
      </div>

      <div className="col-lg-7 d-flex align-items-center justify-content-center vh-100">
        <div className="col-md-7">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="text-center mb-4">
              <img src="/assets/img/logo.svg" alt="Logo" />
            </div>
            <div className="text-center mb-3">
              <h2 className="text-center">Forgot Password?</h2>
              <br/>
              <p class="mb-0">
                If you forgot your password, well, then we'll email you
                link to reset your password.
              </p>
            </div>
            <div className="mb-3">
              <label>Email</label>

              <div className="input-group">
                <input
                  type="email"
                  className="form-control"
                  {...register("email", { required: "Email required" })}
                />
                <span className="input-group-text">
                  <i className="ti ti-mail"></i>
                </span>
              </div>

              {errors.email && (
                <small className="text-danger">{errors.email.message}</small>
              )}
            </div>

            <button className="btn btn-primary w-100" disabled={loading}>
              {loading ? "Sending..." : "Submit"}
            </button>

            {/* RESEND */}
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-link"
                style={{color: "#F26522"}}
                onClick={handleResend}
                disabled={cooldown > 0 || resendLoading}
              >
                {cooldown > 0
                  ? `Resend in ${cooldown}s`
                  : resendLoading
                    ? "Resending..."
                    : "Resend Email"}
              </button>
            </div>
            <div className="text-center">
  <Link to="/" className="btn btn-link" style={{ color: "#F26522" }}>
    Return to Sign In
  </Link>
</div>

            {status && <div className="text-center mt-2">{status}</div>}
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
